const profile = {
    title: 'Kabinet',
    myAddress: 'Mənim ünvanlarım',
    historyOrders: 'Sifariş tarixçəsi',
    messages: 'Dəstəklə əlaqə',
    bonuses: 'Sizin bonus xallarınız',
    share: 'Linki paylaşın',
    delivery: 'Çatdırılma və ödəniş',
    aboutCompany: 'Şirkət haqqında',
    downloadApp: 'Proqramı yükləyin',
    signOut: 'Profildən çıxın',
    btnLogoutOk: 'Bəli, çıxın',
    deleteAccount: 'Hesabı silin',
    modalDeleteAccount: {
        title: 'Hesab silinsin?',
        btnDelete: 'Bəli',
        btnClose: 'Xeyir',
    },
    messageSignOut:
        'Profilinizdən çıxdığınız zaman bütün məhsullar səbətinizdən silinəcək. Profildən çıxsın?',
    userPlaceholder: 'İstifadəçi adı',
    emailPlaceholder: 'email',
    copy: 'Link kopyalandı',
    history: {
        repeat: 'Sifarişi təkrarlayın',
        more: 'Daha ətraflı',
        order: 'Sifariş №',
        cancel: 'Sifarişi ləğv edin',
        amount: 'Qiymət: ',
        deliveryAmount: 'Çatdırılma: ',
        quantity: 'Sayı: ',
    },
    agreements: {
        ads: {
            labels: {
                bannerTitle:
                    'Kuryerin gəliş vaxtı, promosyonlar və endirimlər haqqında bilmək istəyirsiniz?',
                modalText:
                    'Siz SMS, push bildirişləri və e-poçt vasitəsilə promosyon təklifləri almağa razılaşırsınız. Siz həmişə cihaz parametrlərində imtina edə bilərsiniz.',
                checkboxLabel:
                    'Push, SMS və e-poçt vasitəsilə sifariş statusları, promosyon təklifləri və yeni məhsullar haqqında bildirişlər almağa razıyam',
            },
            buttons: {
                bannerAgree: 'İstəyin!',
                bannerDecline: 'istəmirəm',
            },
        },
        privacyPolicy: {
            labels: {
                checkboxLabel: 'razıyam',
            },
            buttons: {
                checkboxDocument: 'şəxsi məlumatların emalı',
            },
        },
    },
};

export default profile;
